//#region Function Imports
import React, { useEffect, useState } from 'react';
import { SafeAreaView, StyleSheet, Image, ScrollView, View, Platform, FlatList, TouchableOpacity, useWindowDimensions } from 'react-native';
import CustomButton from '../../../components/CustomButton';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useAccount } from '../../../hooks/useAccount';
import { useTheme } from '@react-navigation/native';
import MyAccountPersonalInformationScreen from './MyAccountPersonalInformationScreen';
import MyAccountEmergencyInformationScreen from './MyAccountEmergencyInformationScreen';
import MyAccountDocumentsScreen from './MyAccountDocumentsScreen';
import { useTranslation } from 'react-i18next';
import { DEFAULTPROFILE } from '../../../img/DefaultProfile';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';
import RoleGuard from '../../../components/RoleGuard';
//#endregion

const MyAccountScreen = ({ }) => {

    //#region Function Definitions
    const { t } = useTranslation();
    const buttonTable = [1, 2, 3, 4];
    const [showPersonalInformation, setShowPersonalInformation] = useState(1)
    const [showEmergencyInformation, setShowEmergencyInformation] = useState(0)
    const [showAccountDocument, setShowAccountDocument] = useState(0)
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { isLoading } = useAccount();
    const { account } = useAccountContext();
    //#endregion

    //#region UseEffect
    useEffect(() => {
    }, [])
    //#endregion

    if (isLoading === false) {
        return (
            <SafeAreaView style={styles.mainView}>
            </SafeAreaView>
        )
    }
    else {
        return (
            <SafeAreaView style={styles.mainView}>
                <Image
                    style={{
                        width: 120,
                        height: 120,
                        marginTop: '3%',
                        borderRadius: 100,
                        borderWidth: 1,
                        alignSelf: 'center',
                    }}
                    source={{ uri: `data:image/png;base64,${account?.photograph === '' || account?.photograph === undefined ? DEFAULTPROFILE : account?.photograph}` }}
                />
                <CustomLabel
                    type="ACCOUNT"
                    value={account?.name}
                />
                <CustomLabel
                    type="ACCOUNT_SENIORITY"
                    value={account?.seniority}
                />
                <ScrollView

                    //horizontal={false}
                    //showsHorizontalScrollIndicator={true}
                    directionalLockEnabled={true}
                    alwaysBounceVertical={Platform.OS !== 'web'}
                >
                    <FlatList
                        data={buttonTable}
                        horizontal
                        contentContainerStyle={{ alignSelf: 'flex-start', paddingHorizontal: 12 }}
                        scrollEnabled={Platform.OS !== 'web'}
                        showsVerticalScrollIndicator={false}
                        showsHorizontalScrollIndicator={Platform.OS !== 'web'}
                        renderItem={({ index }) => {
                            // create menu buttons for leave management
                            return (
                                <SafeAreaView>
                                    {index == 1 && <CustomButton
                                        onPress={() => {
                                            setShowPersonalInformation(1);
                                            setShowEmergencyInformation(0);
                                            setShowAccountDocument(0);
                                        }}
                                        text={t('navigate:personalInfo')}
                                        iconName='log-out-outline'
                                        show={showPersonalInformation ? 'HOME_SELECTED' : 'HOME'}
                                        type={showPersonalInformation ? 'HOME_SELECTED' : 'HOME'}
                                        textTop='0'
                                        isGradient={showPersonalInformation ? true : false}
                                        sz={25}
                                    />}
                                    {index == 2 &&
                                        <RoleGuard parentTask={TASKS.ALLEMPLOYEETASKS} task={TASK_OPTIONS.EMERGENCYCONTACT} requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    setShowPersonalInformation(0);
                                                    setShowEmergencyInformation(1);
                                                    setShowAccountDocument(0);
                                                }}
                                                text={t('navigate:emergencyInfo')}
                                                iconName='logo-buffer'
                                                show={showEmergencyInformation ? 'HOME_SELECTED' : 'HOME'}
                                                type={showEmergencyInformation ? 'HOME_SELECTED' : 'HOME'}
                                                textTop='0'
                                                isGradient={showEmergencyInformation ? true : false}
                                                sz={25}
                                            />
                                        </RoleGuard>}
                                    {index == 3 &&
                                        <RoleGuard parentTask={TASKS.ALLEMPLOYEETASKS} task={TASK_OPTIONS.DOCUMENTS} requireCRUD>
                                            <CustomButton
                                                onPress={() => {
                                                    setShowPersonalInformation(0);
                                                    setShowEmergencyInformation(0);
                                                    setShowAccountDocument(1);
                                                }}
                                                text={t('navigate:documents')}
                                                iconName='bar-chart-outline'
                                                show={showAccountDocument ? 'HOME_SELECTED' : 'HOME'}
                                                type={showAccountDocument ? 'HOME_SELECTED' : 'HOME'}
                                                textTop='0'
                                                isGradient={showAccountDocument ? true : false}
                                                sz={25}
                                            />
                                        </RoleGuard>
                                    }
                                </SafeAreaView>
                            )
                        }}
                        keyExtractor={item => `${item}`}
                    />
                </ScrollView>
                <View style={styles.mainSubStyle}>
                    {showPersonalInformation ?
                        <MyAccountPersonalInformationScreen />
                        : <></>}
                    {showEmergencyInformation ?
                        <MyAccountEmergencyInformationScreen />
                        : <></>}
                    {showAccountDocument ?
                        <MyAccountDocumentsScreen />
                        : <></>}
                </View>
            </SafeAreaView>
        )
    }
};

const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    doc: {
        flex: 1,
    },
    mainSubStyle: {
        flex: 15,
        width: Platform.OS === 'web' ? '80%' : '100%'
    },
});

export default MyAccountScreen;